import {BaseContainerModel} from '../../base-container.model';
import { bl_fi_forex_data_source_history_RowClass } from '../../../dbschema';

export class ForexDataSourceHistoryContainerModel extends BaseContainerModel {
  bl_fi_forex_data_source_history: bl_fi_forex_data_source_history_RowClass = new bl_fi_forex_data_source_history_RowClass();
}